import type { IconName } from '@sparklayer-io/spark-dash-ui/components/ui/icon/types';
import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Icon } from '@ui/themed';
import type { ReactNode } from 'react';

type StatusBannerTone = 'blue' | 'green';

const TONE_CLASSES: Record<StatusBannerTone, { frame: string; tile: string; title: string }> = {
  blue: {
    frame: 'border-spark-info-border bg-spark-info-soft',
    tile: 'bg-spark-info-solid',
    title: 'text-spark-info-soft-text',
  },
  green: {
    frame: 'border-spark-success-border bg-spark-success-soft',
    tile: 'bg-spark-success-solid',
    title: 'text-spark-success-soft-text',
  },
};

export function StatusBanner({
  tone,
  icon,
  title,
  description,
  onClick,
}: {
  tone: StatusBannerTone;
  icon: IconName;
  title: string;
  description: ReactNode;
  onClick: () => void;
}) {
  const tones = TONE_CLASSES[tone];

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex w-full items-stretch overflow-clip rounded-xl border text-start shadow-sm',
        tones.frame,
      )}
    >
      <span
        className={cn(
          'flex w-14 shrink-0 items-start justify-center pt-4 text-spark-text-inverse',
          tones.tile,
        )}
      >
        <Icon name={icon} size="lg" />
      </span>
      <span className="flex flex-1 items-center justify-between gap-4 p-4">
        <span className="flex flex-col gap-1">
          <span className={cn('font-medium text-sm', tones.title)}>{title}</span>
          <span className="text-sm text-spark-text-secondary">{description}</span>
        </span>
        <Icon name="chevronRight" />
      </span>
    </button>
  );
}
